/**
 * RealEstateSearchLayer用のタグ同期システム
 * PropertySelectionGridとRealEstateSearchポップアップ間でタグデータを同期するためのユーティリティ
 */

import { createIndexedPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const REAL_ESTATE_SEARCH_TAG_UPDATE_EVENT = "updateRealEstateSearchTags";

const { dispatch, addListener } = createIndexedPropertyGridPopupSyncSystem<
  string[]
>(REAL_ESTATE_SEARCH_TAG_UPDATE_EVENT);

/**
 * RealEstateSearchのタグ更新イベントを発火する
 * ポップアップが開かれた際に最新のタグでフォームを更新するために使用
 * @param index 不動産検索結果のインデックス
 * @param tags 更新するタグの配列
 */
export const dispatchRealEstateSearchTagUpdate = (
  index: number,
  tags: string[]
): void => {
  dispatch(index, tags);
};

/**
 * RealEstateSearchのタグ更新イベントリスナーを追加する
 * @param targetIndex リスナーを登録する対象のインデックス
 * @param callback タグが更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addRealEstateSearchTagUpdateListener = (
  targetIndex: number,
  callback: (tags: string[]) => void
): (() => void) => {
  return addListener(targetIndex, callback);
};
